export default __webpack_public_path__ + "static/media/Capture Isomnia III.f96cdf81.jpg";